import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const ActionTypes = Constants.ActionTypes;

let _quiz = [];
let _questions = [];
let _score = 0;
const _lastQuestionId = null;
let _lastQuestionSaved = false;
let _lastQuestionSkipped = false;
let _lastActionType = null;
let _loading = false;
let _activeQuestionIndex = 0;
let _results = [];

const CHANGE_EVENT = 'change'; // globālais

const QuizStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
	* @param {function} callback
	*/
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  addQuiz(quiz) {
    _quiz = quiz;
  },

  getQuiz() {
    return _quiz;
  },

  addQuestions(questions) {
    _questions = [];
    for (const index in questions) {
      // default vērtības
      const questionDefault = {
        _id: null,
        title: '',
        answers: [],
        type: 'text',
      };

      _questions.push(_.assign(questionDefault, questions[index]));
    }
  },

  getQuestion(index) {
    return _questions[index];
  },

  getLast() {
    return _questions[_lastQuestionId];
  },

  getAll() {
    return _questions;
  },

  /**
	 * @param {boolean} vai pēdējāis jautājums ir saglabāts
	 */
  setLastQuestionSaved(val) {
    _lastQuestionSaved = val;
  },

  /**
	 * @param {boolean} vai pēdējāis jautājums ir izlaists
	 */
  setLastQuestionSkipped(val) {
    _lastQuestionSkipped = val;
  },

  /**
	 * @param {boolean} vai notiek ielādēšana
	 */
  setLoading(val) {
    _loading = val;
  },

  getLoading() {
    return _loading;
  },

  getLastQuestionSaved() {
    return _lastQuestionSaved;
  },

  getLastQuestionSkipped() {
    return _lastQuestionSkipped;
  },

  /**
	 * @param {number} progress procentos
	 */
  setScore(val) {
    _score = val;
  },

  getScore(val) {
    return _score;
  },

  /**
	 * @param {string} pēdējais rīcības tips
	 */
  setLastActionType(val) {
    _lastActionType = val;
  },

  getLastActionType() {
    return _lastActionType;
  },

  getActiveQuestionIndex() {
    return _activeQuestionIndex;
  },

  setActiveQuestionIndex(value) {
    _activeQuestionIndex = parseInt(value);
  },

  setResults(answer_id, question_id, result) {
    if (!_results[result]) _results[result] = [];
    _results[result].push(question_id);
  },

  getResults() {
    return _results;
  },

  resetResults() {
    _results = [];
  },


});

QuizStore.dispatchToken = AppDispatcher.register((action) => {
  QuizStore.setLastActionType(action.type);
  if (
    action.type == ActionTypes.QUIZ_LOAD_SUCCESS
  ) {
    QuizStore.setLoading(false);
    if (action.quiz) {
      const quiz = action.quiz;
      // quiz.questions = null;
      QuizStore.addQuiz(quiz);
    }

    if (action.questions) {
      QuizStore.addQuestions(action.questions);
    }
    if (action.score) {
      QuizStore.setScore(action.score);
    }
  } else if (
    action.type == ActionTypes.QUIZ_ANSWER_SAVE
  ) {
    const index = QuizStore.getActiveQuestionIndex();
    QuizStore.setActiveQuestionIndex(index + 1);

    QuizStore.setResults(action.answer_id, action.question_id, action.result);

    QuizStore.setLoading(true);
    QuizStore.emitChange();
  } else if (
    action.type == ActionTypes.QUIZ_RESULTS_SAVE
  ) {
    console.log('Results saved');
  } else if (
    action.type == ActionTypes.QUIZ_RESULTS_SAVE_FAIL
  ) {
    console.log('Failed to save results');
  }
});

module.exports = QuizStore;
